import React, { useEffect, useState } from 'react'
import './AllRewardProducts.css'
import { useDispatch, useSelector } from 'react-redux';
import { allRewardProductsData } from '../../features/AllRewardProducts/AllRewardProductsSlice';
import { getProductByIdData } from '../../features/getProductById/getProductByIdSlice';
import { Link } from 'react-router-dom';
import { Delete, Edit } from '@mui/icons-material';
import { deleteProductByIdData } from '../../features/deleteProduct/deleteProductByIdSlice';

const AllRewardProducts = () => {
  let pathname = window.location.pathname;
    const dispatch = useDispatch();
    const [Rerender, setRerender] = useState(false)
    const finalData = useSelector
    ((state) => state.allRewardProducts.data.data);
    const pending = useSelector((state) => state.allRewardProducts.pending);
    const error = useSelector((state) => state.allRewardProducts.error);
    // const finalData = data.data;

    // console.log(finalData)
    // const [updatedSeriesList, setupdatedSeriesList]= useState({
    //   'newList' : []
    // })


    useEffect(() =>{
          dispatch(allRewardProductsData());
      },[Rerender])
     
      const handleEditClick =(productId)=>{
       
        dispatch(getProductByIdData(productId)).then((res) => {
      console.log(res);
    });

      }
      const handleDeleteClick =(productId)=>{
        dispatch(deleteProductByIdData(productId)).then((res) => {
          console.log(res);
          setRerender(!Rerender)
        });
      }
  
      
      return (
    <div className='rewardProduct'>
        <div className="rewardProductWrapper">
            <h3 className="rewardProductHeading">
               All Reward Product List
            </h3>
            <div className="rewardProductTableWrapper">

            

            <table className="rewardProductTable">
                <tr>
                    <th>S.no.</th>
                    <th>Product Name</th>
                    <th>Product Image</th>
                    <th>Coin Value</th>
                    <th>Action</th>
                    
                </tr>

                {
              finalData?.map((item, index) => (

                <tr key={index}>
                        <td className='serialNumber'>{`${index+1}`}</td>
                        <td className='productName'>{item?.title}</td>
                        <td className='productImageColumn'><div className='productImage'><img src={item.image} alt="" /></div></td>
                        <td className='coinValue'>{item?.coinValue}</td>
                        <td className='actionColumn'> <div className="editAndDelete">
                      <Link
                        to="/admin/edit-product"
                        className="editProduct"
                        onClick={(e) => handleEditClick(item._id)}
                      >
                        <Edit className="editCampaignIcon" />
                        Edit
                      </Link>
                      <Link
                        to="/admin/all-reward-products"
                        className="deleteProduct"
                        onClick={(e) => handleDeleteClick(item._id)}
                      >
                        <Delete className="deleteCampaignIcon" />
                        Delete
                      </Link>
                    </div>
                    </td>
                        {/* <td className='editAndDelete'><button className='editProductButton' onClick={handleEditClick}>Edit</button><button className='deleteProductButton' onClick={handleDeleteClick}>Delete</button></td> */}
                
                    </tr>
                
              ))
              }
            </table>

            
            </div>
        </div>
      
    </div>
  )
}


export default AllRewardProducts
